import React from "react";
import store from "../store/store";
import { Provider } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./style.css"
import ChatbaseWidget from "../components/chatbot/ChatbaseWidget";
function App({ children }) {
  return (
    <Provider store={store}>
      <div className="page-body">{children}</div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <ChatbaseWidget />
    </Provider>
  );
}

export default App;
